
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center justify-center pt-20"
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/9c2c06a8b6ef6910b64d9ff9e72e051a.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/50"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-2xl">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Professional Piercing in Wichita
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed">
            Expert body piercing services with jewelry included. Walk-ins welcome at our two Wichita locations. Experience professional piercing artistry from our talented team.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button 
              onClick={scrollToContact}
              className="bg-red-600 text-white px-8 py-4 rounded-lg hover:bg-red-700 transition-all font-bold text-lg cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              Visit Us Today
            </button>
            <a 
              href="tel:3163057076"
              className="bg-white text-gray-900 px-8 py-4 rounded-lg hover:bg-gray-200 transition-all font-bold text-lg cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl transform hover:scale-105 text-center"
            >
              Call Justin
            </a>
            <a 
              href="tel:3168807760"
              className="bg-white text-gray-900 px-8 py-4 rounded-lg hover:bg-gray-200 transition-all font-bold text-lg cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl transform hover:scale-105 text-center"
            >
              Call Tia
            </a>
          </div>
          <div className="mt-8 flex flex-wrap items-center gap-6 text-white">
            <div className="flex items-center gap-2">
              <i className="ri-vip-diamond-line text-2xl text-red-500"></i>
              <span className="text-lg">Jewelry Included</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-user-smile-line text-2xl text-red-500"></i>
              <span className="text-lg">Expert Artists</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-first-aid-kit-line text-2xl text-red-500"></i>
              <span className="text-lg">Aftercare Support</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
